var map = {
	"./aao.svg": "vtSj",
	"./about-associations.svg": "nA97",
	"./about-education.svg": "z46s",
	"./about-family.svg": "u82R",
	"./arrow.svg": "7Hhe",
	"./facebook.svg": "85DX",
	"./family.svg": "2+5z",
	"./home-expertise.svg": "+Fkt",
	"./home-hygiene.svg": "ghoX",
	"./home-lab.svg": "Y2sf",
	"./home-retention.svg": "IvkG",
	"./home-star.svg": "aoje",
	"./instagram.svg": "OCqi",
	"./location.svg": "UqX2",
	"./logo-color.svg": "G8lN",
	"./logo-emblem.svg": "baU6",
	"./logo-white-01.svg": "lUrH",
	"./logo-white.svg": "kaZ4",
	"./longevity.svg": "ul2o",
	"./phone.svg": "9pTP",
	"./quotes.svg": "3GQY",
	"./treatments-technology.svg": "hoy3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 1